import { useCallback } from 'react';

import { TOPIC } from 'Util/Message/TopicName';
import postMessageHelper from 'Util/Message/postMessageHelper';

import useTracking from './useTracking';

const CATEGORY = 'Popup Announcement';

const POPUP_ANNOUNCEMENT_ACTIONS = {
  DISPLAY_OCCURRENCE: 'Display Occurrence',
  DISPLAY_CAMPAIGN_NAME: 'Display Campaign Name',
  DISPLAY_TIME: 'Display Time More Than 10 Second',
  SWIPE_ACTION: 'Swipe To Last Slide',
  CALL_TO_ACTION: 'Click Call To Action Button',
  CLOSE_POPUP: 'Click Close Popup Announcement',
  DO_NOT_SHOW_AGAIN: 'Click Do Not Show Again',
};

export const genPopupAnnouncementEvent = (action, label) => ({
  category: CATEGORY,
  action,
  label,
});

function usePopupAnnouncementTracking() {
  const { logAction } = useTracking();

  const logOccurrence = useCallback(
    (label, campaignName) => {
      logAction(genPopupAnnouncementEvent(POPUP_ANNOUNCEMENT_ACTIONS.DISPLAY_OCCURRENCE, label));
      postMessageHelper(TOPIC.POPUP_ANNOUNCEMENT_OCCURRENCE, { campaignName });
    },
    [logAction]
  );

  const logCampaignName = useCallback(
    (label) => {
      logAction(genPopupAnnouncementEvent(POPUP_ANNOUNCEMENT_ACTIONS.DISPLAY_CAMPAIGN_NAME, label));
    },
    [logAction]
  );

  const logOnMoreThanTenSecond = useCallback(
    (label, campaignName) => {
      logAction(genPopupAnnouncementEvent(POPUP_ANNOUNCEMENT_ACTIONS.DISPLAY_TIME, label));
      postMessageHelper(TOPIC.POPUP_ANNOUNCEMENT_MORE_THAN_TEN_SECOND, { campaignName });
    },
    [logAction]
  );

  const logOnLastSlide = useCallback(
    (label, campaignName) => {
      logAction(genPopupAnnouncementEvent(POPUP_ANNOUNCEMENT_ACTIONS.SWIPE_ACTION, label));
      postMessageHelper(TOPIC.POPUP_ANNOUNCEMENT_LAST_SLIDE, { campaignName });
    },
    [logAction]
  );

  const logOnCallToAction = useCallback(
    (label, campaignName) => {
      logAction(genPopupAnnouncementEvent(POPUP_ANNOUNCEMENT_ACTIONS.CALL_TO_ACTION, label));
      postMessageHelper(TOPIC.POPUP_ANNOUNCEMENT_CALL_TO_ACTION, { campaignName });
    },
    [logAction]
  );

  const logOnClose = useCallback(
    (label, campaignName) => {
      logAction(genPopupAnnouncementEvent(POPUP_ANNOUNCEMENT_ACTIONS.CLOSE_POPUP, label));
      postMessageHelper(TOPIC.POPUP_ANNOUNCEMENT_ON_CLOSE, { campaignName });
    },
    [logAction]
  );

  const logOnNotShowAgain = useCallback(
    (label, campaignName) => {
      logAction(genPopupAnnouncementEvent(POPUP_ANNOUNCEMENT_ACTIONS.DO_NOT_SHOW_AGAIN, label));
      postMessageHelper(TOPIC.POPUP_ANNOUNCEMENT_NOT_SHOW_AGAIN, { campaignName });
    },
    [logAction]
  );

  return {
    logOccurrence,
    logCampaignName,
    logOnMoreThanTenSecond,
    logOnLastSlide,
    logOnCallToAction,
    logOnClose,
    logOnNotShowAgain,
  };
}

export { usePopupAnnouncementTracking };
